import { all } from "redux-saga/effects";
import { dotXetChungChiSaga } from "./dotXetChungChiSaga";
import { dotXetChungChiPhamViSaga } from "./dotXetChungChiPhamViSaga";
import { dotXetChungChiThamSoXetSaga } from "./dotXetChungChiThamSoXetSaga";
import { chungChiSinhVienSaga } from "./chungChiSinhVienSaga";
import { dotXetChungChiPhamViSinhVienSaga } from "./dotXetChungChiPhamViSinhVienSaga";

export default function* xetChungChiSagaWrapper() {
    yield all([
         dotXetChungChiSaga(),
         dotXetChungChiPhamViSaga(),
         dotXetChungChiThamSoXetSaga(),
         chungChiSinhVienSaga(),
         dotXetChungChiPhamViSinhVienSaga(),
    ]);
}